const id_master_finance = {
    "": "keuangan"
}

export default id_master_finance;